import { render } from "./scourtHeader.vue?vue&type=template&id=0880f414"
import script from "./scourtHeader.vue?vue&type=script&lang=js"
export * from "./scourtHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__